export enum DipRegistrationAdobeUrls {
    TEST = 'https://assets.adobedtm.com/178dbd5c3653/bed0bf145e08/launch-b3ab8762bdf8-development.min.js',
    PROD = 'https://assets.adobedtm.com/178dbd5c3653/bed0bf145e08/launch-002840c58e1c.min.js'
}
